import { Box, Typography, useTheme } from '@mui/material';
import classnames from 'classnames';
import Legend from '../../components/Legend';
import useTeceoStyles from '../../useTeceoStyles';
import mediaNameComposition from './mediaNameComposition';

type DropboxHowItWorksProps = {
  fileSplitter: string;
};

const DropboxHowItWorks = ({ fileSplitter }: DropboxHowItWorksProps) => {
  const { classes: teceoClasses } = useTeceoStyles();
  const theme = useTheme();

  return (
    <>
      <Typography gutterBottom color="textSecondary" className={teceoClasses.lowercase}>
        Esta configuração permite que as fotos de produtos sejam sincronizadas com o sistema de
        forma automática. Para isso faça o upload das fotos para a pasta da sua marca no dropbox,
        seguindo este padrão de nomenclatura:
      </Typography>

      <Typography color="textSecondary" gutterBottom>
        <span
          className={classnames(teceoClasses.primary, teceoClasses.clickable)}
          title={mediaNameComposition.productCode}
        >
          123456
        </span>
        {fileSplitter}
        <Box
          component="span"
          className={teceoClasses.clickable}
          title={mediaNameComposition.colorCode}
          sx={{ color: 'info.main' }}
        >
          987
        </Box>
        {fileSplitter}
        <span
          className={classnames(teceoClasses.tertiary, teceoClasses.clickable)}
          title={mediaNameComposition.photoOrder}
        >
          2
        </span>
        {fileSplitter}
        <span className={teceoClasses.clickable} title={mediaNameComposition.productName}>
          CALÇA JEANS BOOTCUT BORDADA
        </span>
      </Typography>

      <Legend
        color="primary"
        description={mediaNameComposition.productCode}
        typographyProps={{ variant: 'caption' }}
      />
      <Legend
        color="info"
        description={mediaNameComposition.colorCode}
        typographyProps={{ variant: 'caption' }}
      />
      <Legend
        color="tertiary"
        description={mediaNameComposition.photoOrder}
        typographyProps={{ variant: 'caption' }}
      />
      <Legend
        color={theme.palette.text.secondary}
        description={mediaNameComposition.productName}
        typographyProps={{ variant: 'caption' }}
      />
    </>
  );
};

export default DropboxHowItWorks;
